<div id="header-wrapper">
  <h6 id="tracker-subtitle">Créez ici vos propres trackers pour personnaliser et optimiser le suivi de vos patients.</h6>
</div>
<div *ngIf="!error && !isLoading && customTrackers && customTrackers.length > 0; else innerLoading"
     id="custom-tracker-list">
  <table class="table">
    <thead>
    <tr>
      <th scope="col" id="type-col">Type</th>
      <th scope="col" id="name-col">Nom</th>
      <th scope="col" id="value-col">Valeur</th>
      <th scope="col" id="actions-col">Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr (onDelete)="deleteCustomTrackerConfirmation(tracker)"
        *ngFor="let tracker of customTrackers"
        [actionLoading]="customTrackerAction === tracker"
        [diaryTypes]="diaryTypes"
        [diaryType]="tracker.diaryType"
        [maxValue]="tracker.max"
        [name]="tracker.name"
        [type]="tracker.type"
        msd-custom-tracker-cell>
    </tr>
    </tbody>
  </table>
</div>

<ng-template #innerLoading>
  <ngx-inner-loading class="flex-center" [empty]="customTrackers?.length === 0" [error]="!!error"
                     [loading]="isLoading" (retry)="loadCustomTrackers()" [loadingDescription]="'Chargement...'"
                     [emptyDescription]="'Aucun tracker'" [errorDescription]="error" [retryButtonText]="'Réessayer'">
  </ngx-inner-loading>
</ng-template>
